/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService
 */
import * as References from './CatalogResourceChirpFrontendService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
  registerQuery,
} from 'data-fetching-client';

import type { AdditionalContextArgs } from './CatalogResourceChirpFrontendService.dfc.new';

const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService#getCatalogResources
 */

export const GET_CATALOG_RESOURCES_QUERY: RegisteredQuery<
  'getCatalogResources',
  References.GetCatalogResourcesRequestType,
  References.GetCatalogResourcesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: 'getCatalogResources',
  args: ['requestedResources'],
  fetcher(
    request: References.GetCatalogResourcesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetCatalogResourcesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getCatalogResourcesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
